module.exports = __webpack_public_path__ + "static/media/wind-warning.48ceadc1.svg";